"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ri = require("react-icons/ri");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProfileImage = function ProfileImage(_ref) {
  var image = _ref.image,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 70 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: profileCSS({
      size: size
    })
  }, image ? /*#__PURE__*/_react["default"].createElement(_.View, {
    as: "img",
    extend: profileImageCSS,
    src: image
  }) : /*#__PURE__*/_react["default"].createElement(_ri.RiUser3Line, {
    size: 20
  }));
};

var profileCSS = function profileCSS(_ref2) {
  var size = _ref2.size;
  return function (_ref3) {
    var _ref3$theme = _ref3.theme,
        grid = _ref3$theme.grid,
        colors = _ref3$theme.colors,
        shadows = _ref3$theme.shadows;
    return {
      width: size - 2 * grid,
      height: size - 2 * grid,
      borderRadius: '50%',
      padding: grid / 2,
      border: "2px solid ".concat(colors.bg),
      transition: 'border-color 200ms ease-in-out',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      background: colors.bg,
      boxShadow: shadows.big,
      color: colors.body,
      '&:hover': {
        borderColor: colors.primary,
        color: colors.primary
      }
    };
  };
};

var profileImageCSS = {
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  objectFit: 'cover' // background: "hotpink",
  // display: "flex",
  // justifyContent: "center",
  // alignItems: "center",

};
var _default = ProfileImage;
exports["default"] = _default;